(function() {
    'use strict';

    const TR = angular.module('TR');
    TR.directive('bd4Track', bd4Track);

    function bd4Track($location, bd4t) {
        return {
            restrict: 'E',
            link($scope) {

                function bd4PageView() {
                    const path = $location.path();

                    if (path === '/') {
                        bd4t('initPage', { type: 'home', section: 'home' });
                    } else if (path === '/holidays') {
                        bd4t('initPage', { type: 'home', section: 'holidays' });
                    } else if (path === '/hotels') {
                        bd4t('initPage', { type: 'home', section: 'hotels' });
                    }
                    bd4t('send', 'pageview');
                }

                $scope.$on('$routeChangeStart', bd4PageView);

            }
        };
    }

    })();
